import StoredLayout from '../../layouts/StoredLayout'
import MaterialDesignIcons from './MaterialDesignIcons'
export default StoredLayout(MaterialDesignIcons)



// WEBPACK FOOTER //
// ./src/icons/material-design-icons/index.js